import { render, staticRenderFns } from "./DadosCompra.vue?vue&type=template&id=01bf75dc&"
import script from "./DadosCompra.vue?vue&type=script&lang=js&"
export * from "./DadosCompra.vue?vue&type=script&lang=js&"
import style0 from "./DadosCompra.vue?vue&type=style&index=0&id=01bf75dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports